import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';

var TAGToggleButton = function TAGToggleButton(_ref) {
  var sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(ToggleButton, _objectSpread(_objectSpread({}, props), {}, {
    sx: [{
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'neutrals.primary',
      color: 'text.secondary',
      '&:hover': {
        backgroundColor: 'info.light',
        color: 'secondary'
      },
      '&:active': {
        backgroundColor: 'secondary.light',
        color: 'secondary'
      },
      '&.Mui-selected': {
        backgroundColor: 'secondary',
        color: 'text.light',
        '&:hover': {
          backgroundColor: 'info.light',
          color: 'secondary'
        }
      },
      '&.Mui-disabled': {
        backgroundColor: 'backgrounds.white',
        color: 'text.disabled'
      }
    }, sx]
  }));
};

export default TAGToggleButton;